import React, { memo, MouseEvent } from 'react';
import cn from 'clsx';
import { KitchenCollection } from 'modules/collections';
import { createElementKey } from 'utils';
import { Link } from '../link';
import { HoverPriceMediaCardSwiper, PriceMediaCard } from '../price-media-card';
import { ProductSchema } from '../product-schema';
import {
  catalogFirstImage,
  catalogGrid,
  catalogImage,
  catalogImageWrapper,
  catalogLink,
  newCatalogFirstImage,
  newCatalogGrid,
  newCatalogImage,
} from './gallery-catalog-styles';

type GalleryCatalogProps = {
  catalog: KitchenCollection[];
  cardRefCb?: (el: HTMLAnchorElement | null) => void;
  className?: string;
  downloadCatalog: React.ReactNode;
  renderCardContent: (collection: KitchenCollection) => React.ReactNode;
  children?: React.ReactNode;
  onCardClick: (collection: KitchenCollection, position: number) => void;
  isNew?: boolean;
};

export const GalleryCatalog: React.FC<GalleryCatalogProps> = memo(
  ({ catalog, cardRefCb, children, className, downloadCatalog, onCardClick, isNew = false, renderCardContent }) => {
    const handleCardClick = (collection: KitchenCollection, position: number) => () => {
      onCardClick(collection, position);
    };

    const handleCardWheelClick = (collection: KitchenCollection, position: number) => (e: MouseEvent) => {
      if (e.button === 1) {
        handleCardClick(collection, position)();
      }
    };

    return (
      <>
        <ul
          data-testid="gallery-catalog"
          className={cn(catalogGrid, { [newCatalogGrid]: isNew }, className)}>
          {catalog.map((collection, index: number) => (
            <li  key={createElementKey('collection', index)}>
              <Link
                className={isNew ? catalogLink : ''}
                data-position={index}
                onAuxClick={handleCardWheelClick(collection, index)}
                onClick={handleCardClick(collection, index)}
                href={collection.productUrl}
                refCb={cardRefCb}
                title={collection.displayedName}>
                <PriceMediaCard>
                  {isNew ? (
                    <HoverPriceMediaCardSwiper
                      keyName="gallery-catalog-simage"
                      photosName={`Фото ${collection.displayedName}`}
                      photosSrc={collection.mediaMainPhoto}
                      imageClass={cn(newCatalogImage, { [newCatalogFirstImage]: index === 0 })}
                    />
                  ) : (
                    <div
                      className={cn(catalogImageWrapper, {
                        [catalogFirstImage]: index === 0,
                      })}>
                      <img
                        alt={`Фото ${collection.displayedName}`}
                        className={catalogImage}
                        src={collection.mediaMainPhoto?.[0]}
                      />
                    </div>
                  )}

                  {renderCardContent(collection)}
                </PriceMediaCard>
              </Link>
            </li>
          ))}
          {downloadCatalog}
          {children}
        </ul>

        <ProductSchema />
      </>
    );
  }
);
